import { useOktaAuth } from '@okta/okta-react';
import { ToolTile } from '@optools/app/components/tool-tile';
import { Page } from '@optools/components/layout/page';
import { useAccessCheck } from '@optools/hooks/useAccessCheck';
import { createFileRoute } from '@tanstack/react-router';
import {
  ClipboardCheck,
  FileVideo2,
  Film,
  ListChecks,
  Logs,
  RedoDot,
  Replace,
  RouteIcon,
  SatelliteDish,
  Tv,
  UserSearch,
} from 'lucide-react';

export const Route = createFileRoute('/')({
  component: RoutComponent,
});

function Guest() {
  return (
    <>
      <h3 className="mb-2 text-4xl font-bold">Welcome to the Streaming Operator Platform</h3>
      <p className="text-sm font-normal">
        In order to use the application, you will need to log in via Okta.
      </p>
    </>
  );
}

function Tiles() {
  const {
    showAudit,
    showBtcTools,
    showEsni,
    showIpOverride,
    showLogger,
    showMediaValidation,
    showMilestones,
    showOverrides,
    showPartnerStreamDelivery,
    showQaTools,
    showUserLookup,
  } = useAccessCheck();

  return (
    <div className="grid gap-4 sm:grid-cols-[repeat(auto-fill,minmax(180px,1fr))]">
      {showBtcTools && <ToolTile icon={SatelliteDish} title="BTC Tools" to="/btc-tools/schedule" />}
      {showOverrides && <ToolTile icon={RedoDot} title="Overrides" to="/overrides/session" />}
      {showIpOverride && (
        <ToolTile icon={Replace} title="Blackout Override" to="/ip-override/user-lookup" />
      )}
      {showLogger && <ToolTile icon={Tv} title="Logger" to="/logger" />}
      {showMediaValidation && (
        <ToolTile icon={ClipboardCheck} title="Media Validation" to="/media-validation/litmus" />
      )}
      {showMilestones && <ToolTile icon={Film} title="Milestones" to="/milestones" />}
      {showAudit && <ToolTile icon={Logs} title="Audit & Logging" to="/audit/audits" />}
      {showPartnerStreamDelivery && (
        <ToolTile icon={RouteIcon} title="Partner Delivery" to={`/partner/mapping`} />
      )}
      {showEsni && <ToolTile icon={FileVideo2} title="ESNI Management" to="/esni/media" />}
      {showUserLookup && <ToolTile icon={UserSearch} title="User Lookup" to="/user-lookup" />}
      {showQaTools && <ToolTile icon={ListChecks} title="QA Tools" to="/qa-tools/dev-configs" />}
    </div>
  );
}

function RoutComponent() {
  const { authState } = useOktaAuth();
  const isAuthenticated = !!authState?.isAuthenticated;

  const element = isAuthenticated ? <Tiles /> : <Guest />;

  return <Page title="Home">{element}</Page>;
}
